<template>
  <div id="app">
    <div id="driver">
      <div class="login_password">
        <router-view @applyId="reApplyId" :applyId="applyId" />
      </div>
    </div>
  </div>
</template>

<script>
import "./assets/css/iconfont.css";
export default {
  name: "App",
  data() {
    return {
      applyId: ""
    };
  },
  methods: {
    reApplyId(x) {
      this.applyId = x;
    }
  }
};
</script>

<style>

li {
  list-style: none;
}
html,
body {
  background: #f5f5f5;
  height: 100%;
}
#driver {
  width: 360px;
  height: 700px;
  margin: 0px auto 0 auto;
  border: solid 1px #ccc;
  border-radius: 20px;
  background: #333;
  box-shadow: 6px 6px 15px #999;
}
.login_password {
  margin: 30px 10px;
  height: 640px;
  position: relative;
  text-align: left;
  background: #f5f5f5;
}

.clearfloat:after{display:block;clear:both;content:"";visibility:hidden;height:0} 
.clearfloat{zoom:1} 
@media (max-width: 600px) {
  #app {
    margin-top: 0;
    height: 100%;
  }

  #driver {
    width: 100%;
    height: 100%;
    margin: 0px auto 0 auto;
    border: solid 1px #ccc;
    border-radius: 0px;
    box-shadow: none;
  }
  .login_password {
    margin: 0px;
    position: relative;
    text-align: left;
    height: 100%;
  }
}
/*调整下拉箭头到文字的距离*/
.ivu-collapse > .ivu-collapse-item > .ivu-collapse-header > i {
  transition: transform 0.2s ease-in-out;
  margin-right: 6px;
}

.amap-logo {
  display: none;
  opacity: 0 !important;
}
.amap-copyright {
  opacity: 0;
}

.lycol .picker-items{
  display: block;
}
.lycol .picker-items .picker-item{
  color: #ccc;
}
.lycol .picker-items .picker-selected{
  color: #333;
}
.lycol .picker-items .picker-slot{
  display: inline-block;
}
.lycol3 .picker-items .picker-slot{
  width: 33.33%;
}
.lycol5 .picker-items .picker-slot{
  width: 20%;
}
.lycol2 .picker-items .picker-slot{
  width: 50%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue